"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGddDisabled = exports.isGddReplacementDate = exports.getGddFormattedDay = exports.getGddNote = exports.getGDDNoteTitle = exports.getGddStatus = void 0;
var Wordings_1 = __importDefault(require("../../Constants/Wordings"));
var Context_1 = require("../../Enums/Context");
var Formatting_1 = require("../../Formatting");
var DateFormat_1 = require("../Dates/DateFormat");
var getGddStatus = function (groupDeliveryDay, options) {
    var _a;
    var context = (options || {}).context;
    var isSubContext = !!context && Context_1.SubscriptionContexts.includes(context);
    if (isSubContext) {
        if (groupDeliveryDay.isFullForSubscription)
            return Wordings_1.default.GROUP_DELIVERY_DAY.FULL.STATUS;
        if (groupDeliveryDay.isGddDisabledForSubscription)
            return Wordings_1.default.GROUP_DELIVERY_DAY.NOT_AVAILABLE.STATUS;
        return undefined;
    }
    else {
        if (((_a = groupDeliveryDay.timeSlot) === null || _a === void 0 ? void 0 : _a.hasSubstitute) && !(0, exports.isGddReplacementDate)(groupDeliveryDay))
            return Wordings_1.default.GROUP_DELIVERY_DAY.SUBSTITUTE.STATUS;
        if (groupDeliveryDay.isTooLate)
            return Wordings_1.default.GROUP_DELIVERY_DAY.TOO_LATE.STATUS;
        if (groupDeliveryDay.isFull)
            return Wordings_1.default.GROUP_DELIVERY_DAY.FULL.STATUS;
        if (groupDeliveryDay.isGddDisabled)
            return Wordings_1.default.GROUP_DELIVERY_DAY.NOT_AVAILABLE.STATUS;
        if (!groupDeliveryDay.isNextDeliveryAvailable)
            return Wordings_1.default.GROUP_DELIVERY_DAY.NOT_AVAILABLE.STATUS;
        return undefined;
    }
};
exports.getGddStatus = getGddStatus;
var getGDDNoteTitle = function (groupDeliveryDay, options) {
    var deliveryPoint = (options || {}).deliveryPoint;
    var prefix = deliveryPoint ? (deliveryPoint === null || deliveryPoint === void 0 ? void 0 : deliveryPoint.isHomeDelivery) ? 'Message de notre partenaire' : 'Message du point relais' : 'Message de notre partenaire ou point relais';
    var formattedDay = (0, exports.getGddFormattedDay)(groupDeliveryDay);
    var date = formattedDay ? "pour le<br></span> ".concat((0, Formatting_1.capitalize)(formattedDay)) : '';
    return "<span class=\"font-normal\">".concat(prefix, " ").concat(date);
};
exports.getGDDNoteTitle = getGDDNoteTitle;
var getGddNote = function (groupDeliveryDay, options) {
    var _a;
    var deliveryPoint = (options || {}).deliveryPoint;
    var dlpNote = deliveryPoint === null || deliveryPoint === void 0 ? void 0 : deliveryPoint.note;
    var gddNote = groupDeliveryDay === null || groupDeliveryDay === void 0 ? void 0 : groupDeliveryDay.note;
    var gddTimeSlotNote = (_a = groupDeliveryDay === null || groupDeliveryDay === void 0 ? void 0 : groupDeliveryDay.timeSlot) === null || _a === void 0 ? void 0 : _a.note;
    return gddTimeSlotNote || gddNote || dlpNote || undefined;
};
exports.getGddNote = getGddNote;
var getGddFormattedDay = function (groupDeliveryDay, options) {
    var _a = options || {}, context = _a.context, condensed = _a.condensed, showHours = _a.showHours, showTheoricalDate = _a.showTheoricalDate;
    if (!!context && Context_1.SubscriptionContexts.includes(context.toUpperCase())) {
        return (0, DateFormat_1.formatGDD)(groupDeliveryDay, { condensed: condensed || !showHours });
    }
    else {
        return (0, DateFormat_1.formatTimeSlot)(groupDeliveryDay.timeSlot, {
            condensed: condensed,
            showHours: showHours,
            theorical: showTheoricalDate
        });
    }
};
exports.getGddFormattedDay = getGddFormattedDay;
var isGddReplacementDate = function (groupDeliveryDay) {
    return !!groupDeliveryDay.dayLabel && ((0, DateFormat_1.tmsToFormat)(groupDeliveryDay.timeSlot.date, 'EEEE') !== groupDeliveryDay.dayLabel.toLowerCase());
};
exports.isGddReplacementDate = isGddReplacementDate;
var isGddDisabled = function (groupDeliveryDay, options) {
    var context = (options || {}).context;
    var isSubContext = !!context && Context_1.SubscriptionContexts.includes(context);
    return isSubContext ? groupDeliveryDay.isGddDisabledForSubscription : groupDeliveryDay.isGddDisabled && !groupDeliveryDay.isTooLate;
};
exports.isGddDisabled = isGddDisabled;
exports.default = { getGddStatus: exports.getGddStatus, getGDDNoteTitle: exports.getGDDNoteTitle, getGddNote: exports.getGddNote, getGddFormattedDay: exports.getGddFormattedDay, isGddReplacementDate: exports.isGddReplacementDate, isGddDisabled: exports.isGddDisabled };
//# sourceMappingURL=GroupDeliveryDay.js.map